import Firebase from "firebase"
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCEr1UhcqmC_3gSKV1jiysTKRUblFyPApY",
    authDomain: "clone-c6ecb.firebaseapp.com",
    projectId: "clone-c6ecb",
    storageBucket: "clone-c6ecb.appspot.com",
    messagingSenderId: "826481197791",
    appId: "1:826481197791:web:663734b9c7ab5d1097df6a",
    measurementId: "G-V1TK5HP6TW"
  };

  const FirebaseApp = Firebase.initializeApp(firebaseConfig);
  const auth= Firebase.auth();
  const db=FirebaseApp.firestore();
  
  export {auth,db}